<div class="container px-0 bank-container">
  <div class="row d-flex justify-content-center currentDate mb-3">
    Current as of <strong> {{currentDate | date: 'longDate'}}</strong>
    <!--TODO:  when ETL is implemented, this date should reflect when ETL was last run? -->
  </div>
  <div class="row topBtmBorder mx-0">
    <div class="col-4 px-0 bank time py-3">
      <div class="row top-row mx-0" [class.btmBorder]="isCollapse">
        <div class="bank-content">
          <h4>Banked Time</h4>
          <div class="hours">Available: {{ bankedAvailable - bankedTaken }} hours</div>
        </div>
      </div>
      <div class="row bottom-row mx-0 collapse multi-collapse" id="summary-cdo">
        <div class="bank-content">
          <div class="bank-text">
            <ul>
              @if (cdoBank.allocated + cdoBank.carried - cdoBank.taken > 0) {
                <li>Compressed day off
                  (CDO):
                {{cdoBank.allocated + cdoBank.carried - cdoBank.taken}} hours </li>
              }
              @if (otBankPrev.allocated + otBankPrev.carried - otBankPrev.taken > 0) {
                <li>Prior year's
                  overtime:
                {{otBankPrev.allocated + otBankPrev.carried - otBankPrev.taken}} hours</li>
              }
              @if (otBankCurr.allocated + otBankCurr.carried - otBankCurr.taken > 0) {
                <li>Current year's
                  overtime:
                {{otBankCurr.allocated + otBankCurr.carried - otBankCurr.taken}} hours</li>
              }
              @if (statBank.allocated + statBank.carried - statBank.taken > 0) {
                <li>Stat holiday:
                {{statBank.allocated + statBank.carried - statBank.taken}} hours</li>
              }
              @if (councilBank.allocated + councilBank.carried - councilBank.taken > 0) {
                <li>Council
                  overtime:
                {{councilBank.allocated + councilBank.carried - councilBank.taken}} hours </li>
              }
            </ul>
          </div>
          @if (bankedAvailable > 0 || bankedPlanned > 0 || bankedTaken > 0) {
            <div class="chart-container">
              <div class="chart">
                <canvas baseChart [data]="cdoChartData" [type]="'doughnut'" [legend]="false"
                  [options]="bankedTimeOptions" #cdo="base-chart">
                </canvas>
              </div>
              <div class="chart-legend">
                <ul>
                  @if (bankedPlanned > 0) {
                    <li>
                      <div class="legend-color legend-planned"></div>
                      <div class="legend-label">Planned: ({{ bankedPlanned }} hours)
                      </div>
                    </li>
                  }
                  @if (bankedAvailable > 0) {
                    <li>
                      <div class="legend-color legend-avail"></div>
                      <div class="legend-label">Available: ({{ bankedAvailable - bankedTaken }} hours)
                      </div>
                    </li>
                  }
                  @if (bankedTaken > 0) {
                    <li>
                      <div class="legend-color legend-taken"></div>
                      <div class="legend-label">Used: ({{ bankedTaken }} hours)</div>
                    </li>
                  }
                </ul>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    @if (holidayBank !== null) {
      <div class="col-4 px-0 bank holiday py-3">
        <div class="row top-row mx-0" [class.btmBorder]="isCollapse">
          <div class="bank-content">
            <h4>Vacation</h4>
            <div class="hours">
              Available:
              <!-- {{ holidayBank.allocated + holidayBank.carried - holidayBank.taken - pendingVacation }} -->
              {{ vacationRemaining }}
            hours</div>
          </div>
        </div>
        <div class="row bottom-row mx-0 collapse multi-collapse" id="summary-holiday">
          <div class="bank-content">
            @if (holidayBank.allocated > 0 || holidayBank.taken > 0) {
              <div class="chart-container">
                <div class="chart">
                  <canvas baseChart [data]="holidayChartData" [type]="'doughnut'" [legend]="false"
                    [options]="doughnutChartOptions" #holiday="base-chart">
                  </canvas>
                </div>
                <div class="chart-legend">
                  <ul>
                    @if (holidayBank.taken > 0) {
                      <li>
                        <div class="legend-color legend-vacay-taken"></div>
                        <div class="legend-label">Used: ({{ vacationUsed }} hours)
                        </div>
                      </li>
                    }
                    <!-- <li *ngIf="pendingVacation > 0">
                    <div class="legend-color legend-vacay-planned"></div>
                    <div class="legend-label">Planned: ({{pendingVacation}} hours)
                    </div>
                  </li> -->
                  <li>
                    <div class="legend-color legend-vacay-remaining"></div>
                    <div class="legend-label">Available: ({{ vacationRemaining }} hours)</div>
                  </li>
                </ul>
              </div>
            </div>
          }
          <div class="chart-other">
            <span class="hours">
              <!-- Total: {{ holidayBank.allocated + holidayBank.carried }} hours  -->
              Total: {{ doubleDigitTotal(vacationEntitlement + vacationCarried) }} hours
              <!-- <button type="button"
              class="btn btn-link btn-bank" placement="right"
              ngbTooltip="You must use a minmum of 105 hours this year." tooltipClass="tooltip-class">
              <i class="fa-solid fa-circle-info"></i>
            </button> -->
          </span>
          <ul>
            <!-- <li>Annual entitlement: {{ holidayBank.allocated}} hours</li> -->
            <!-- <li>Carried over from previous year(s): {{holidayBank.carried}} hours</li> -->
            <li>Annual entitlement: {{ vacationEntitlement }} hours</li>
            <li>Carried over from previous year(s): {{ vacationCarried }} hours</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
}
@if (sickBank !== null) {
  <div class="col-4 px-0 bank sick py-3">
    <div class="row top-row mx-0" [class.btmBorder]="isCollapse">
      <div class="bank-content">
        <h4>Sick</h4>
        <div class="hours">Available: {{ sickRemaining }} hours
        </div>
      </div>
    </div>
    <div class="row bottom-row mx-0 collapse multi-collapse" id="summary-sick">
      <div class="bank-content">
        @if (sickBank.taken > 0 || sickBank.allocated > 0) {
          <div class="chart-container">
            <div class="chart">
              <canvas baseChart [data]="sickChartData" [type]="'doughnut'" [legend]="false"
                [options]="doughnutChartOptions" #sick="base-chart">
              </canvas>
            </div>
            <div class="chart-legend">
              <ul>
                <li>
                  <div class="legend-color legend-sick-taken"></div>
                  <div class="legend-label">Used: ({{ sickUsed }} hours)</div>
                </li>
                <li>
                  <div class="legend-color legend-sick-remaining"></div>
                  <div class="legend-label">Available: ({{ sickRemaining }} hours)</div>
                </li>
              </ul>
            </div>
          </div>
        }
        <div class="chart-other">
          <span class="hours">
            Total: {{ doubleDigitTotal(sickEntitlement + sickCarried) }} hours @if (lastPayPeriod && lastPayPeriod.endDate) {
            <button type="button"
              class="btn btn-link btn-bank" placement="right"
              ngbTooltip="Accumulated as of {{lastPayPeriod!.endDate | date:'longDate'}}."
              tooltipClass="tooltip-class">
              <i class="fa-solid fa-circle-info"></i>
            </button>
          }
        </span>
        <ul>
          <li>Accumulated this year: {{ sickEntitlement }} hours</li>
          <li>Carried over from previous year(s): {{ sickCarried }} hours</li>
        </ul>
      </div>
    </div>
  </div>
</div>
}
</div>

<div class="row show-more">
  <button class="btn btn-link collapsed" type="button" data-bs-toggle="collapse" data-bs-target=".multi-collapse"
    aria-expanded="false" aria-controls="summary-cdo summary-holiday summary-sick" (click)="toggleSummary()">
    <span class="more">Show more <i class="fa-solid fa-circle-chevron-down"></i></span>
    <span class="less">Show less <i class="fa-solid fa-circle-chevron-up"></i></span>
  </button>
</div>
</div>